// Copyright (c) 2016 Deere & Company

import TransferApprovals from '../../product/transfers/state-connector';

export default {
    component: TransferApprovals,
    name: 'TRANSFER_APPROVALS',
    path: 'transfers'
};




// WEBPACK FOOTER //
// ./src/routes/products/transfer-approvals-route.js